module.exports = __webpack_public_path__ + "static/media/dial.009f7999.ico";